import DropdownTemplateView from '../../../../DropdownTemplateView'
import $ from 'jquery'

export default class AssignAllMenu extends DropdownTemplateView {
    constructor({
        assignAllLabel = '',
        unassignAllLabel = '',
        onAssignAll = () => {},
        onUnassignAll = () => {},
    }) {
        super()

        this.params = {
            assignAllLabel,
            unassignAllLabel,
        }

        this.callbacks = {
            onAssignAll,
            onUnassignAll
        }
    }

    templateHtml() {
        return "<div class='userManagement_hierarchyAssignmentsEditor_assignAllMenu'>" +
               "  <div class='item assignAll'><%-params.assignAllLabel%></div>" +
               "  <div class='item unassignAll'><%-params.unassignAllLabel%></div>" +
               "</div>"
    }

    afterRender() {
        this.find('.assignAll').click(e => {
            e.stopPropagation()
            this.hide()
            this.callbacks.onAssignAll()
        })
        this.find('.unassignAll').click(e => {
            e.stopPropagation()
            this.hide()
            this.callbacks.onUnassignAll()
        })
    }

    mouseDownTargetElement() {
        return $('body')
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/AssignAllMenu.js